<template>
  <transition name="fade">
    <div v-if="visible" class="session-warning">
      <div class="session-warning__info">
        <v-icon class="session-warning__icon">warning</v-icon>
        <p v-html="$t(`${namespace}.text`)" class="session-warning__text" />
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { SESSION_EXPIRES_TIME } from 'utils/constants'

export default {
  name: 'SessionExpiresWarning',
  computed: {
    ...mapState({
      sessionExpiresTime: ({ sessionExpiresTime }) => sessionExpiresTime.date
    }),

    sessionExpired () {
      return Boolean(this.$route.query && this.$route.query.sessionExpired)
    }
  },
  data () {
    return {
      namespace: 'Components.SessionExpiresWarning',
      visible: false
    }
  },
  methods: {
    ...mapActions({
      setSessionExpiresTime: 'sessionExpiresTime/set'
    }),

    clearUrlQueryParam () {
      setTimeout(() => {
        this.$router.push(this.$route.path).catch(() => {})
      }, 100)
    },

    setVisibility (boolean = true) {
      this.visible = boolean
    },

    toggleVisible () {
      const nowInMilliseconds = new Date().getTime()
      const expiresDateInMilliseconds = this.sessionExpiresTime
        ? new Date(this.sessionExpiresTime).getTime()
        : null
      const isSessionExpired = this.sessionExpired || (expiresDateInMilliseconds && nowInMilliseconds >= expiresDateInMilliseconds)

      if (isSessionExpired) {
        this.setVisibility(true)
        localStorage.removeItem(SESSION_EXPIRES_TIME)
        this.setSessionExpiresTime(null)
        this.clearUrlQueryParam()
        setTimeout(() => this.setVisibility(false), 10000)
        return
      }

      this.setVisibility(false)
    }
  },
  mounted () {
    this.toggleVisible()
  }
}
</script>

<style lang="scss" scoped>
.session-warning {
  background-color: var(--attention);
  border-bottom: 1px solid var(--gray-4);
  left: 0;
  padding: 0 16px;
  position: fixed;
  right: 0;
  text-align: center;
  top: 0;
  z-index: 1000;
}

.session-warning__info {
  align-items: center;
  display: flex;
  justify-content: center;
  justify-items: center;
  min-height: 60px;
}

.session-warning__icon {
  color: var(--warning-2) !important;
  margin-right: 8px;
}

.session-warning__text {
  margin: 0;

  span {
    color: var(--gray-8);
    font-weight: 600;
  }
}
</style>
